/** @jsx jsx */
import { Box, Flex } from "@eworkit/iris";
import { UnreadMessagesIndicator } from "@eworkit/messenger";
import { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { router } from "@/views/router";

import { RouteNavItem } from "../components/RouteNavItem";

export interface IChatRouteNavItemProps {
  onClick?: () => void;
}

export const ChatRouteNavItem: FC<IChatRouteNavItemProps> = memo(({ onClick }) => {
  const { t } = useTranslation("session");

  const messageCenterRoute = router.get("message-center");

  return (
    <Box sx={{ position: "relative" }}>
      <RouteNavItem
        variant="icon"
        icon="message"
        iconActive="message"
        text={t("COMPONENTS.TOPBAR.BUTTON_CHAT")}
        path={messageCenterRoute.path}
        exact={false}
        testName={messageCenterRoute.testName}
        onClick={onClick}
      />
      <Flex
        justifyContent="center"
        alignItems="center"
        sx={{ position: "absolute", pointerEvents: "none", width: 20, height: 20, top: 7, right: 7 }}>
        <UnreadMessagesIndicator counter />
      </Flex>
    </Box>
  );
});
